import { Reveal, SectionLabel } from "@/components/Reveal";

const sections = [
  {
    title: "Éditrice du site",
    content: [
      "ARGIA Admin — Aurélie Violet, entrepreneure individuelle",
      "Gestion administrative indépendante — 95 Chemin des Dames, 64520 Guiche, France",
      "SIRET : 518 308 960 00039",
      "Membre du réseau national AADPROX",
      "Téléphone : 06 33 83 74 56",
      "Contact : a.violet@aadprox.com",
    ],
  },
  {
    title: "Directrice de la publication",
    content: ["Aurélie Violet"],
  },
  {
    title: "Hébergement",
    content: [
      "Ce site est hébergé par Emergent — emergent.sh",
      "Les données sont hébergées au sein de l'infrastructure de l'hébergeur.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    content: [
      "L'ensemble des contenus du site (textes, logos, images) est la propriété d'ARGIA Admin ou de ses partenaires (réseau AADPROX) et ne peut être reproduit sans autorisation écrite préalable.",
    ],
  },
  {
    title: "Responsabilité",
    content: [
      "Les informations fournies sur ce site le sont à titre indicatif. ARGIA Admin s'efforce d'en assurer l'exactitude mais ne saurait être tenue responsable d'erreurs ou d'omissions.",
      "L'activité est couverte par une assurance Responsabilité Civile Professionnelle.",
    ],
  },
];

export default function MentionsLegales() {
  return (
    <div className="mx-auto max-w-3xl px-6 pb-24 pt-16 lg:pt-24" data-testid="mentions-legales-page">
      <Reveal>
        <SectionLabel>Informations légales</SectionLabel>
        <h1 className="mt-6 font-display text-4xl font-bold tracking-tight text-argia-ink sm:text-5xl">Mentions légales</h1>
      </Reveal>
      <div className="mt-12 space-y-10">
        {sections.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.06}>
            <section>
              <h2 className="font-display text-xl font-bold text-argia-ink">{s.title}</h2>
              <div className="mt-3 space-y-2">
                {s.content.map((p) => (
                  <p key={p} className="text-base leading-relaxed text-argia-muted">{p}</p>
                ))}
              </div>
            </section>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
